import { render, staticRenderFns } from "./RangeWidget.vue?vue&type=template&id=8fb9c0a4&lang=pug&"
import script from "./RangeWidget.vue?vue&type=script&lang=js&"
export * from "./RangeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports